module.exports = __webpack_public_path__ + "img/pdf-download-icon.b5c72120.png";